import React, { useContext } from 'react';
import { IStyleContext, StyleContext } from '../../styleState/styleContext';
import { ICustomMediaSettingsForUpdate } from 'types';
import { FormSection } from 'components/EntityForm/FormSection';
import { MediaGroup } from './MediaGroup';
import classNames from 'classnames';

interface IProps {
	data: ICustomMediaSettingsForUpdate;
	activeGroupId: string;
}

export const MediaFields: React.FC<IProps> = ({ data, activeGroupId }) => {
	const { selectedLanguage } = useContext<IStyleContext>(StyleContext);
	const isVisible = data.languageId === selectedLanguage && data.groups.some((el) => el.id === activeGroupId);

	return (
		<div className={classNames({ hidden: !isVisible })} data-test="MediaFields">
			{data.groups.map((el) => (
				<div key={el.id} className={classNames({ hidden: el.id !== activeGroupId })}>
					<FormSection
						translationKey={el.key}
						translationNameSpace="mediaSettings"
						testId={`MediaField-${el.key}`}
						isCollapsible={false}>
						<MediaGroup data={el} languageId={data.languageId} />
					</FormSection>
				</div>
			))}
		</div>
	);
};
